import React, { FC, SVGProps } from 'react';

export const LightBulb: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.75 27.3125V30.875C23.75 31.5049 23.4998 32.109 23.0544 32.5544C22.609 32.9998 22.0049 33.25 21.375 33.25H16.625C15.9951 33.25 15.391 32.9998 14.9456 32.5544C14.5002 32.109 14.25 31.5049 14.25 30.875V27.3125"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 1.1875V3.5625"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.375 17.8125H4.75"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.9375 5.9375L7.67917 7.61108"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.625 17.8125H33.25"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.0625 5.9375L30.3208 7.61108"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1153 27.3125H23.8845C25.6487 26.4368 27.1295 25.0803 28.1562 23.3995C29.1829 21.7187 29.7137 19.7819 29.6874 17.8125C29.6374 14.9936 28.4953 12.3042 26.5017 10.3106C24.5082 8.31707 21.8187 7.17501 18.9999 7.125C16.1799 7.17506 13.4896 8.31799 11.4958 10.3129C9.5021 12.3078 8.36076 14.9989 8.31237 17.8188C8.28725 19.7872 8.8186 21.7226 9.84524 23.4022C10.8719 25.0818 12.3521 26.4373 14.1153 27.3125V27.3125Z"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 33.25V36.8125"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 21.375V27.3125"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4375 17.8125L19 21.375L22.5625 17.8125"
      stroke={props.stroke || '#BEDFE5'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
